import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const deleteAIModelPricingSchema = z.object({
  aiProviderId: z.string().min(1),
  modelId: z.string().min(1),
});

export const deleteAIModelPricing = mutator({
  schema: deleteAIModelPricingSchema,
  resolve: {
    aiProvider: { kind: "aiProvider", from: "aiProviderId" },
  },
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args }) => {
    const existing = await tx.run(
      zql.aiModelPricing
        .where("aiProviderId", args.aiProvider.id)
        .where("modelId", args.modelId)
        .one()
    );
    if (existing) {
      await tx.mutate.aiModelPricing.delete({
        aiProviderId: args.aiProvider.id,
        modelId: args.modelId,
      });
    }
  },
});
